module.exports = __webpack_public_path__ + "img/bg1_bottom.0149bdfa.png";